import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding" }

import { computed, onBeforeMount, ref, shallowRef } from 'vue'
import { useRouter } from 'vue-router'

import { auth } from '@/services/auth'
import { storage } from '@/helpers/storage'
import { Mixpanel } from '@/analytics/mixpanel'
import { maybeSyncAnalyticsIds } from '@/analytics/logic'

import Questionnaire from '@/app/components/onboarding/pages/Questionnaire.vue'
import Signup from '@/app/components/onboarding/pages/Signup.vue'
import Trial from '@/app/components/onboarding/pages/Trial.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Onboarding',
  setup(__props) {

const router = useRouter()

const pages = shallowRef([
  { name: 'signup', component: Signup },
  { name: 'questionnaire', component: Questionnaire },
  { name: 'trial', component: Trial },
])

const currentPageIndex = ref(0)
const currentPage = computed(() => {
  return pages.value[currentPageIndex.value]
})

onBeforeMount(async () => {
  if (auth.loggedIn() && !auth.isTemporaryUser()) {
    // Skip the onboarding if the user is logged in and
    // doesn't have a position saved (we clear the position
    // when the user has finished the questionnaire).
    if (!storage.getItem('sf_lq_position')) {
      router.replace({ name: 'home' })
      return
    }

    // Skip to the questionnaire if the user is logged in
    // and has a position saved in local storage.
    currentPageIndex.value = pages.value.findIndex(
      (page) => page.name === 'questionnaire',
    )
  }

  trackPageView()
})

async function nextPage(): Promise<void> {
  if (currentPageIndex.value + 1 < pages.value.length) {
    currentPageIndex.value++
    await maybeSyncAnalyticsIds()
    trackPageView()
    return
  }

  router.replace({ name: 'billing' })
}

function trackPageView(): void {
  // The questionnaire page has its own logic
  // for tracking page views (because it has
  // many sub pages).
  if (currentPage.value.name === 'questionnaire') {
    return
  }

  Mixpanel.trackOnboardingPageView(currentPage.value.name)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentPage.value.component), { nextOnboardingPage: nextPage }))
      ]),
      _: 1
    })
  ]))
}
}

})